import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "preview",
    "videoPreview",
    "upload",
    "imageInput",
    "videoInput",
    "error",
  ]
  static values = {
    maxVideoSize: Number,
    videosAllowed: Boolean,
    planUrl: String,
  }

  disconnect() {
    if (this.currentVideoURL) {
      URL.revokeObjectURL(this.currentVideoURL)
    }
  }

  preview(event) {
    const file = event.target.files[0]
    if (!file) return

    this.clearError()

    if (file.type.startsWith("image/")) {
      this.previewImage(file)
    } else if (file.type.startsWith("video/")) {
      const rejection = this.rejectionFor(file)
      if (rejection) {
        this.reject(rejection)
        return
      }

      this.previewVideo(file)
    }

    this.uploadTarget.classList.add("hidden")
  }

  previewImage(file) {
    const reader = new FileReader()
    reader.onload = (e) => {
      this.previewTarget.src = e.target.result
      this.previewTarget.classList.remove("hidden")
      this.videoPreviewTarget.classList.add("hidden")
    }
    reader.readAsDataURL(file)
  }

  previewVideo(file) {
    // Move file to video input for backend
    const dataTransfer = new DataTransfer()
    dataTransfer.items.add(file)
    this.videoInputTarget.files = dataTransfer.files

    this.imageInputTarget.value = ""

    const url = URL.createObjectURL(file)
    this.videoPreviewTarget.src = url
    this.videoPreviewTarget.load() // Required for iOS to properly load the video
    this.videoPreviewTarget.classList.remove("hidden")
    this.previewTarget.classList.add("hidden")

    // Store URL for potential cleanup later
    if (this.currentVideoURL) {
      URL.revokeObjectURL(this.currentVideoURL)
    }
    this.currentVideoURL = url
  }

  rejectionFor(file) {
    if (this.hasVideosAllowedValue && !this.videosAllowedValue) {
      return {
        message: "Videos sind im kostenlosen Tarif nicht verfügbar.",
        offerUpgrade: true,
      }
    }

    if (this.hasMaxVideoSizeValue && file.size > this.maxVideoSizeValue) {
      const limit = Math.round(this.maxVideoSizeValue / (1024 * 1024))
      return {
        message: `„${file.name}“ ist zu groß. Videos dürfen höchstens ${limit} MB haben.`,
        offerUpgrade: false,
      }
    }

    return null
  }

  reject(rejection) {
    this.showError(rejection)

    this.imageInputTarget.value = ""
    this.videoInputTarget.value = ""
  }

  showError({ message, offerUpgrade }) {
    if (!this.hasErrorTarget) return

    this.errorTarget.textContent = message
    this.errorTarget.classList.remove("hidden")

    // Guests cannot upgrade — the link is only rendered for the event owner.
    if (offerUpgrade && this.hasPlanUrlValue && this.planUrlValue) {
      this.errorTarget.appendChild(this.buildUpgradeLink())
    }
  }

  buildUpgradeLink() {
    const link = document.createElement("a")
    link.href = this.planUrlValue
    link.className = "underline font-bold ml-1"
    link.textContent = "Jetzt upgraden →"
    return link
  }

  clearError() {
    if (!this.hasErrorTarget) return

    this.errorTarget.textContent = ""
    this.errorTarget.classList.add("hidden")
  }
}
